module.exports = __webpack_public_path__ + "static/img/product05.dd3b95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product05.png
// module id = YQNa
// module chunks = 1